var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.786104 3.99006H2.15186C2.58064 3.99006 2.93796 3.63274 2.93796 3.20396C2.93796 2.75929 2.58064 2.40991 2.15186 2.40991H0.786104C0.35732 2.40991 0 2.75929 0 3.20396C0 3.63274 0.35732 3.99006 0.786104 3.99006ZM5.30422 3.83919H15.3568C15.7221 3.83919 16 3.56128 16 3.20396C16 2.8387 15.7221 2.56078 15.3568 2.56078H5.30422C4.9469 2.56078 4.66104 2.8387 4.66104 3.20396C4.66104 3.56128 4.9469 3.83919 5.30422 3.83919ZM0.786104 8.79403H2.15186C2.58064 8.79403 2.93796 8.43671 2.93796 7.99999C2.93796 7.56326 2.58064 7.21388 2.15186 7.21388H0.786104C0.35732 7.21388 0 7.56326 0 7.99999C0 8.43671 0.35732 8.79403 0.786104 8.79403ZM5.30422 8.64316H15.3568C15.7221 8.64316 16 8.35731 16 7.99999C16 7.64267 15.7221 7.36475 15.3568 7.36475H5.30422C4.9469 7.36475 4.66104 7.64267 4.66104 7.99999C4.66104 8.35731 4.9469 8.64316 5.30422 8.64316ZM0.786104 13.5901H2.15186C2.58064 13.5901 2.93796 13.2327 2.93796 12.804C2.93796 12.3593 2.58064 12.0099 2.15186 12.0099H0.786104C0.35732 12.0099 0 12.3593 0 12.804C0 13.2327 0.35732 13.5901 0.786104 13.5901ZM5.30422 13.4392C4.9469 13.4392 4.66104 13.1613 4.66104 12.804C4.66104 12.4387 4.9469 12.1608 5.30422 12.1608H15.3568C15.7221 12.1608 16 12.4387 16 12.804C16 13.1613 15.7221 13.4392 15.3568 13.4392H5.30422Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/List.c5e9c415bc5e44dd08b78daeba23aeba.svg";